import { Components, Theme } from '@mui/material';

export const MuiInput: Partial<Components<Theme>> = {
  MuiInput: {
    styleOverrides: {
      root: ({ theme }) => {
        return {
          fontFamily: 'Inter',
          fontWeight: 400,
          fontSize: '16px',
          borderRadius: '24px',
          background: 'none',
          minWidth: '50px',
          border: 'none',
          padding: '16px 0',
          '&:before': {
            display: 'none',
          },
          '&:after': {
            display: 'none',
          },
          '& .MuiInputBase-input': {
            '&::placeholder': {
              color: theme.palette.text.disabled,
              opacity: 1,
              fontWeight: 400,
              fontSize: '16px',
            },
          },
          '& + .MuiFormHelperText-root': {
            margin: 0,
          },
        };
      },
      focused: ({ theme }) => ({
        backgroundColor: theme.palette.common.black,
        '& fieldset': {
          '&.MuiOutlinedInput-notchedOutline': {
            border: 'none',
          },
        },
      }),
    },
  },
};
